<template>
    <div>
        <div class="columns">
          <div class="column">
            <!-- <b-select v-model="perPage" size="is-small">
              <option v-for="(p, index) in pageList" v-bind:key="index" :value="p">{{p}} per page</option>
            </b-select> -->
          </div>
          <div class="column">
            <b-field>
              <b-input v-model="search" placeholder="Search here" size="is-small"></b-input>
            </b-field>
          </div>
        </div>
         <b-table :data="tableData"
          :bordered="bordered" 
          :striped="striped" 
          :narrowed="narrowed" 
          :hoverable="hoverable" 
          :mobile-cards="mobileCards"
          :loading="loading"
          :current-page.sync="page"
          paginated
          backend-pagination
          :per-page="perPage"
          :total="totalData"
           @page-change="onPageChange">
            <template slot-scope="props">
                <slot name="row-content" :item="props"></slot>
            </template>
            <template slot="empty">
                <slot name="empty"></slot>
            </template>
         </b-table>
    </div>
</template>
<script>
export default {
  props: [
    "tableData",
    "bordered",
    "striped",
    "narrowed",
    "hoverable",
    "mobileCards",
    "loading",
    "totalData",
    "perPage"
    // "page"
  ],
  methods: {
    onPageChange(page) {
      this.$emit("onPageChanged", page);
    }
  },
  data() {
    return {
      page: 1,
      pageList: [10, 15, 20, 50],
      search: "",
      perPage: 10
    };
  },
  watch: {
    search(val) {
      this.$emit("onSearchChanged", val);
    },
    perPage(val) {
      this.$emit("onPerPageChanged", val);
    }
  }
};
</script>

